import { useEffect, useState } from "react";
import { updateStoreOpeningHours } from "../../../api/endpoints";
import { useDispatch } from "react-redux";
import { setStore } from "../../../slice/storeSlice";

const SameTimeAllWeek = ({ store, closeModal }) => {
  const [openTime, setOpenTime] = useState({
    from: "",
    to: "",
  });
  const [isFormValid, setIsFormValid] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (openTime.from && openTime.to) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [openTime]);

  const updateOpeningHours = async () => {
    let openingHours = {
      monday: {
        from: openTime.from,
        to: openTime.to,
      },
      tuesday: {
        from: openTime.from,
        to: openTime.to,
      },
      wednesday: {
        from: openTime.from,
        to: openTime.to,
      },
      thursday: {
        from: openTime.from,
        to: openTime.to,
      },
      friday: {
        from: openTime.from,
        to: openTime.to,
      },
      saturday: {
        from: openTime.from,
        to: openTime.to,
      },
      sunday: {
        from: openTime.from,
        to: openTime.to,
      },
    };
    try {
      let response = await fetch(updateStoreOpeningHours + store._id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(openingHours),
      });
      if (response.ok) {
        let store = await response.json();
        console.log(store);
        dispatch(setStore(store));
        closeModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='daysOfWeekPalm'>
        <p>Mon</p>
        <p>Tue</p>
        <p>Wed</p>
        <p>Thur</p>
        <p>Fri</p>
        <p>Sat</p>
        <p>Sun</p>
      </div>
      <div className='generalTimeOpenhrs'>
        <input value={openTime.from} onChange={(e) => setOpenTime({ ...openTime, from: e.target.value })} type='time' name='' id='' />
        -
        <input value={openTime.to} onChange={(e) => setOpenTime({ ...openTime, to: e.target.value })} type='time' name='' id='' />
      </div>
      <div className='buttonDIvUpdateTime3'>
        <button onClick={() => closeModal(false)} className='btn-cancel2'>
          Cancel
        </button>
        {isFormValid ? (
          <button onClick={() => updateOpeningHours()} className='btn-updateHours2'>
            Update Hours
          </button>
        ) : (
          <button className='btn-updateHours2' style={{ opacity: "0.7", cursor: "not-allowed" }} disabled>
            Update Hours
          </button>
        )}
      </div>
    </>
  );
};

export default SameTimeAllWeek;
